import logger from './utils/logger.js';
import { c as calculateDiscount } from './helpers-kA_hdoOI.js';
import { formatProductName } from './utils/product.js';

// Functions:
// 1. Pushes select_item event to dataLayer
//
function isCartItem(product) {
    return product.product !== undefined;
}
const dataLayerSelectItemAccor = ({ product, affiliation, brand, siteFilters = null, index, itemListName, }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    window.dataLayer = window.dataLayer || [];
    if (product) {
        let sku;
        let name;
        let price;
        let categoryName;
        let currency;
        let regularPrice;
        if (isCartItem(product)) {
            sku = product.product.sku;
            name = ((_a = product.product.name_en) === null || _a === void 0 ? void 0 : _a.product_name) || product.product.name;
            price = (_b = product.prices.price.value) !== null && _b !== void 0 ? _b : null;
            categoryName = ((_c = [...product.product.name_en.categories].reverse()[0]) === null || _c === void 0 ? void 0 : _c.name_en) || '';
            currency = product.prices.price.currency;
            regularPrice = product.prices.price.value + ((_e = (_d = product.product.price_gap) === null || _d === void 0 ? void 0 : _d.value) !== null && _e !== void 0 ? _e : 0);
        }
        else {
            sku = product.sku;
            name = ((_f = product.name_en) === null || _f === void 0 ? void 0 : _f.product_name) || product.name;
            price = (_g = product.price_range.maximum_price.final_price.value) !== null && _g !== void 0 ? _g : null;
            categoryName = ((_h = [...product.name_en.categories].reverse()[0]) === null || _h === void 0 ? void 0 : _h.name_en) || '';
            currency = product.price_range.maximum_price.final_price.currency;
            regularPrice = product.price_range.maximum_price.regular_price.value;
        }
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
            event: 'select_item',
            event_value: price,
            event_items: [
                {
                    google_business_vertical: 'retail',
                    id: sku,
                },
            ],
            ecommerce: {
                currency,
                value: price,
                item_list_id: categoryName,
                item_list_name: itemListName,
                items: [
                    {
                        affiliation,
                        index,
                        discount: calculateDiscount(regularPrice, price),
                        item_brand: brand,
                        item_category: categoryName,
                        item_id: sku,
                        item_list_id: categoryName,
                        item_list_name: itemListName,
                        item_name: formatProductName({
                            name,
                            lang: 'en',
                            siteFilters: siteFilters || null,
                        }),
                        price,
                        subscription: 'no',
                    },
                ],
            },
        });
        logger('"select_item" event pushed to dataLayer', {
            category: 'analytics',
        });
    }
    else {
        logger('Product not found: "select_item" event not pushed to dataLayer', {
            category: 'analytics',
        });
    }
};

export { dataLayerSelectItemAccor as d };
//# sourceMappingURL=selectItem-PWuzvZX7.js.map
